import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { MailWarning, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/reports`;
const STATUS = { resent: "retrimis", already_sent: "trimis deja ulterior", not_resendable: "nu se poate regenera", error: "eroare" };

export const MissedReports = () => {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => axios.get(`${API}/missed`).then((r) => setItems(r.data.items || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!items.length) return null;
  const go = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/resend-missed`);
      (r.data.items || []).forEach((i) => toast[i.status === "error" ? "error" : "success"](`${i.label}: ${STATUS[i.status] || i.status}`));
      load();
    } catch (e) { toast.error(e.response?.data?.detail || e.message); }
    setBusy(false);
  };
  const pending = items.filter((i) => !i.resent_at);
  return (
    <div className="flex items-start gap-3 rounded-xl border border-rose-500/30 bg-rose-500/5 px-4 py-3" data-testid="missed-reports">
      <MailWarning className="mt-0.5 h-4 w-4 flex-shrink-0 text-rose-300" />
      <div className="flex-1 text-xs text-rose-100">
        <p className="font-semibold">Emailuri de raport care n-au plecat (ultimele 3 zile)</p>
        <ul className="mt-1 space-y-0.5 text-rose-200/80">
          {items.map((i, k) => (
            <li key={k} data-testid={`missed-report-${k}`}>{new Date(i.sent_at).toLocaleString("ro-RO")} · {i.kind} · {i.resent_at ? (i.resent_at === "skipped" ? "nu mai e nevoie" : "retrimis") : "netrimis"}</li>
          ))}
        </ul>
      </div>
      {pending.length > 0 && (
        <button data-testid="missed-reports-resend-btn" onClick={go} disabled={busy}
          className="inline-flex items-center gap-1.5 rounded-lg bg-rose-500 px-3 py-1.5 text-xs font-medium text-white hover:bg-rose-400 disabled:opacity-50">
          {busy && <Loader2 className="h-3.5 w-3.5 animate-spin" />} Retrimite acum
        </button>
      )}
    </div>
  );
};
